/**
 * Stone Volumes Slider
 * Gère l'effet de slide pour les différents volumes de pierre.
 * Utilise la délégation d'événements pour rester fonctionnel après un re-render
 * (ex. changement de variante sur la page produit).
 */
(function() {
  /**
   * @param {HTMLElement} container - Conteneur [data-stone-volumes]
   * @param {number} index - Index du slide à afficher
   */
  function goToSlide(container, index) {
    const track = container.querySelector('[data-stone-track]');
    const slides = container.querySelectorAll('[data-stone-slide]');
    const dots = container.querySelectorAll('[data-stone-dot]');
    if (!track || index < 0 || index >= slides.length) return;

    /** @type {HTMLElement} */ (track).style.transform = `translateX(-${index * 100}%)`;

    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });
    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
      dot.setAttribute('aria-pressed', i === index ? 'true' : 'false');
    });
  }

  function handleStoneDotClick(event) {
    const dot = event.target.closest('[data-stone-dot]');
    if (!dot) return;

    const container = dot.closest('[data-stone-volumes]');
    if (!container) return;

    const index = parseInt(dot.getAttribute('data-index'), 10);
    if (Number.isNaN(index)) return;

    event.preventDefault();
    goToSlide(container, index);
  }

  function init() {
    document.addEventListener('click', handleStoneDotClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

